import { ButtonText } from '@components/common/Button/styles';
import EditIcon from '@components/icons/editIcon.svg';
import {
  H1 as H1Base,
  Label as LabelBase,
  MEDIA_QUERIES,
} from '@student-coin/coinpaper-components';
import tw, { styled } from 'twin.macro';

export const Label = styled(LabelBase)`
  color: ${({ theme }) => theme.colors.black};
  ${tw`font-semibold`};
`;

export const Info = styled.div`
  ${tw`flex flex-col lg:flex-row lg:gap-x-4`};
  padding-bottom: 1rem;

  @media ${MEDIA_QUERIES.mobileL} {
    padding-bottom: 0;
  }
`;

export const Footer = styled.div`
  ${tw`flex flex-col flex-wrap gap-y-4`};
  padding-top: 1.75rem;
  padding-bottom: 1.5rem;

  @media ${MEDIA_QUERIES.mobileL} {
    ${tw`flex-nowrap`};
  }

  @media ${MEDIA_QUERIES.tablet} {
    padding-top: 1.5rem;
    padding-bottom: 2.5rem;
  }

  ${ButtonText} {
    ${tw`whitespace-nowrap`};
  }
`;

export const H1 = styled(H1Base)`
  margin: 0.5rem 0;
`;

export const Meta = styled.div`
  ${tw`flex flex-wrap justify-between`};
`;

export const UpdatedAtIcon = styled(EditIcon)`
  display: inline;
  vertical-align: initial;
`;

export const DateContainer = styled.div`
  ${tw`flex gap-x-2 items-center`}

  ${Label} {
    ${tw`font-normal`}
  }
`;

export const Ad = styled.div``;

export const Container = styled.div`
  ${tw`col-start-1 col-span-12 sm:col-start-1 md:col-start-1 md:col-span-full lg:col-start-2 lg:col-span-10 xl:col-start-2 xl:col-span-11 2xl:col-span-full 2xl:col-start-1`};
`;
